import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TwoFactorService {
  private apiUrl = environment.backendUrl + '/api/auth';

  constructor(private http: HttpClient) { }

  setup2FA(token: string | null = null): Observable<any> {
    const body = token ? { token } : {};
    return this.http.post(`${this.apiUrl}/setup-2fa/`, body);
  }

  confirm2FA(token: string | null, code: string): Observable<any> {
    const body: any = { code };
    if (token) {
      body.token = token;
    }
    return this.http.post(`${this.apiUrl}/confirm-2fa/`, body);
  }

  resendActivationEmail(token: string | null): Observable<any> {
    const body: any = {};
    if (token) {
      body.token = token;
    }
    return this.http.post(`${this.apiUrl}/resend-activation/`, body);
  }

  disable2FA(): Observable<any> {
    return this.http.post(`${this.apiUrl}/disable-2fa/`, {});
  }

  verify2FA(tempToken: string, code: string, trustDevice: boolean): Observable<any> {
    return this.http.post(`${this.apiUrl}/verify-2fa/`, {
      temp_token: tempToken,
      code,
      trust_device: trustDevice
    });
  }

  requestReset(tempToken: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/reset-request-2fa/`, { temp_token: tempToken });
  }

  confirmReset(uid: string, token: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/reset-confirm-2fa/`, { uid, token });
  }

  activate2FA(uid: string, token: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/activate-2fa/`, { uid, token });
  }
}
